module.exports = __webpack_public_path__ + "e1208c637fc15303975df1bf1f4a1f1d.svg";